import React, { useState, useEffect } from 'react';
import {
  FormControl,
  FormLabel,
  Select,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Input,
  HStack,
  useToast,
} from '@chakra-ui/react';
import api from '../api';

const InvoiceCustomerSelector = ({ customers, selectedCustomer, setSelectedCustomer, fetchCustomers }) => {
  const [isAddClientModalOpen, setIsAddClientModalOpen] = useState(false);
  const [newClientData, setNewClientData] = useState({
    name: '',
    email: '',
    phone_number: '',
    edrpou_code: '',
    address: '',
    bank_name: '',
    bank_number: '',
  });
  const toast = useToast();

  const handleNewClientChange = (e) => {
    const { name, value } = e.target;
    setNewClientData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCreateNewClient = async () => {
    try {
      await api.post('/customers/', newClientData);
      toast({
        title: 'Клієнт створений!',
        description: `Клієнт ${newClientData.name} був успішно створений.`,
        status: 'success',
        duration: 3000,
        isClosable: true,
      });
      setIsAddClientModalOpen(false);
      setNewClientData({
        name: '',
        email: '',
        phone_number: '',
        edrpou_code: '',
        address: '',
        bank_name: '',
        bank_number: '',
      });
      fetchCustomers(); // Refresh the customer list
    } catch (error) {
      toast({
        title: 'Помилка!',
        description: 'Не вдалося створити клієнта.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
    <>
      <FormControl mt="4">
        <FormLabel>Клієнт</FormLabel>
        <HStack>
        <Select
          placeholder="Оберіть клієнта"
          value={selectedCustomer || ''}
          onChange={(e) => setSelectedCustomer(parseInt(e.target.value, 10))} // Ensure we store the customer ID as an integer
        >
          {customers.map((customer) => (
            <option key={customer.id} value={customer.id}>
              {customer.name}
            </option>
          ))}
        </Select>
          <Button colorScheme="blue" onClick={() => setIsAddClientModalOpen(true)}>
            Додати нового
          </Button>
        </HStack>
      </FormControl>

      {/* Add New Client Modal */}
      <Modal isOpen={isAddClientModalOpen} onClose={() => setIsAddClientModalOpen(false)}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Додати клієнта</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl mb="4">
              <FormLabel>Ім'я</FormLabel>
              <Input name="name" value={newClientData.name} onChange={handleNewClientChange} />
            </FormControl>
            <FormControl mb="4">
              <FormLabel>Email</FormLabel>
              <Input name="email" value={newClientData.email} onChange={handleNewClientChange} />
            </FormControl>
            <FormControl mb="4">
              <FormLabel>Номер телефону</FormLabel>
              <Input name="phone_number" value={newClientData.phone_number} onChange={handleNewClientChange} />
            </FormControl>
            <FormControl mb="4">
              <FormLabel>ЄДРПОУ</FormLabel>
              <Input name="edrpou_code" value={newClientData.edrpou_code} onChange={handleNewClientChange} />
            </FormControl>
            <FormControl mb="4">
              <FormLabel>Адреса</FormLabel>
              <Input name="address" value={newClientData.address} onChange={handleNewClientChange} />
            </FormControl>
            <FormControl mb="4">
              <FormLabel>Назва банку</FormLabel>
              <Input name="bank_name" value={newClientData.bank_name} onChange={handleNewClientChange} />
            </FormControl>
            <FormControl mb="4">
              <FormLabel>Номер рахунку</FormLabel>
              <Input name="bank_number" value={newClientData.bank_number} onChange={handleNewClientChange} />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={handleCreateNewClient}>
              Зберегти
            </Button>
            <Button variant="ghost" onClick={() => setIsAddClientModalOpen(false)}>
              Скасувати
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default InvoiceCustomerSelector;
